import { ReactElement, useCallback, useEffect, useRef, useState } from 'react';
import { Link } from '@tanstack/react-router';

import { Issue } from '@/constants';
import { Section } from '../Section';
import { useIssues } from '../Home.hooks';

const TITLE = 'Print Editions';

export default function Issues() {
	const [domNode, setDomNode] = useState<HTMLUListElement | null>(null);
	const ref = useCallback((node: HTMLUListElement | null) => {
		if (node) {
			setDomNode(node);
		}
	}, []);
	const { isLoading, issues } = useIssues();

	const excludeIssues = new Set(['1519', '1520']);

	return (
		<Section domNode={domNode} title={TITLE}>
			{isLoading ? (
				<div>Loading</div>
			) : (
				<ul
					ref={ref}
					className="flex space-x-10 overflow-x-auto p-4 pt-0"
				>
					{issues
						.filter((i: Issue) => !excludeIssues.has(i.id))
						.map(mapItem)}
				</ul>
			)}
		</Section>
	);
}

function mapItem(issue: Issue): ReactElement {
	const { name, slug, id, cover } = issue;
	return (
		<li className="m-0 p-3" key={id}>
			<Link to="/preview/$id" params={{ id: slug ? slug : id }}>
				<img src={cover} className="rounded-lg"></img>
				<small className="mt-2 text-left text-sm font-bold">
					{name}
				</small>
			</Link>
		</li>
	);
}
